"use client";

import Mention from "@tiptap/extension-mention";
import emojiSuggestions from "./emoji-suggestions";

const EmojiExtension = Mention.extend({
	name: "emoji",
}).configure({
	renderHTML({ node }) {
		return ["span", this.HTMLAttributes, `${node.attrs.label ?? node.attrs.id}`];
	},
	HTMLAttributes: {
		class: "content-emoji",
	},
	suggestion: emojiSuggestions,
});

export default EmojiExtension;
